import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from '../../src/i18n';
import { createDate } from '../../utils/date';
import { dateFormats } from '../../constants/consts';

const useStyles = makeStyles(() => ({
  lastUpdateBlock: {
    fontSize: 10,
  },
  lastUpdateDate: {
    display: 'block',
    fontWeight: 'bold',
    fontSize: 10,
  },
}));

const LastUpdate = ({ title, date, className }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={cn(classes.lastUpdateBlock, className)}>
      {t(title)}
      {date && (
        <time className={classes.lastUpdateDate} dateTime={date}>
          {createDate(date).format(dateFormats.basic)}
        </time>
      )}
    </div>
  );
};

LastUpdate.propTypes = {
  title: PropTypes.string,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  className: PropTypes.string,
};

LastUpdate.defaultProps = {
  title: 'operabase.general.m_LASTUPDATE',
};

export default LastUpdate;
